import * as angular from 'angular';
import { IWindowService } from 'angular';
import * as _ from 'lodash';

import { ISdcStore } from 'src/app/sdc/flux/sdc-store.interface';
import { StoreListenerUtils } from 'src/app/shared/services/store-listener-utils/store-listener-utils.service';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { RegentsExam } from '../../../../../../../ng2/shared/constants/regents.constant';
import { IStudentSupport } from '../../../../../../../ng2/shared/typings/interfaces/student-support.interface';
import { ISchoolSupport } from '../../../../../../../ng2/shared/typings/interfaces/support.interface';
import { ImSupport } from '../../../../../../shared/static-models/im-models/im-support.service';

interface ISchoolSupportExtended extends ISchoolSupport {
  _statusObj?: any;
  _matchesFilter?: boolean;
  _enrollments?: number;
  _startDate: string;
  _startAndEndDateString?: string;
  _startAndEndTimeString?: string;
  _leadHumanName?: string;
  _canBeEdited: boolean;
  _meetsOnScheduleString?: string;
  _examSubjectPrepsFor?: string;
}

export class RegentsExamsSupportsTableCtrl {
  static $inject: string[] = [
    '$scope',
    '$window',
    '$state',
    '$filter',
    '$q',
    '$mdDialog',
    'UtilitiesService',
    'SpinnerModal',
    'ConfirmationModal',
    'Support',
    'Rollbar',
    'StoreListenerUtils',
    'SDCStore',
    'ImSupport',
    'sdcActions',
    'ImUser',
  ];

  // Public by default. Accessible to template.
  data: any[];
  storedSchoolSupports: ISchoolSupport[];
  supportFilter: any;
  sortField: string;
  reverseSort: boolean;
  examSubjectsList: any;
  supportLeadsList: any;
  browserTab: string;

  // bindings
  private orderBy: any;
  private initialSortFields: string[];

  public storedStudentSupports;

  constructor(
    public $scope,
    private $window: IWindowService,
    private $state: ng.ui.IStateService,
    private $filter: angular.IFilterService,
    private $q: angular.IQService,
    private $mdDialog: any,
    private UtilitiesService: any,
    private SpinnerModal: any,
    private ConfirmationModal: any,
    private Support: any,
    private Rollbar,
    private storeListenerUtils: StoreListenerUtils,
    private SDCStore: ISdcStore,
    private imSupport: ImSupport,
    private sdcActions,
    private imUser: ImUser,
  ) {}

  $onInit(): void {
    this.storeListenerUtils.startListeningAndLoad(this, [['schoolSupports'], ['studentSupports'], ['students']]);
  }

  setUi(): void {
    this.storedStudentSupports = this.SDCStore.getAllStudentSupports();
    this.storedSchoolSupports = this.SDCStore.getAllSchoolSupports();

    this.orderBy = this.$filter('orderBy');
    this.initialSortFields = ['_statusObj.order', 'metaData.examSubject'];
    this.sortField = '_statusObj.order';
    this.reverseSort = false;
    let tableData;
    if (this.storedSchoolSupports.length) tableData = angular.copy(this.storedSchoolSupports);
    this.data = this.orderBy(this.renderTable(tableData), this.initialSortFields, false);
    this.supportFilter = { examSubject: undefined, activityLeadUserId: undefined };
    this.examSubjectsList = _.uniqBy(
      _.map(this.data, (support: ISchoolSupport) => {
        return {
          k: support.metaData.examSubject,
          human: this.getHumanName(support.metaData.examSubject),
        };
      }),
      'k',
    );
    this.browserTab = 'new';

    const mappedList = _.map(this.data, support => {
      const email = this.imUser.getEffectiveEmail(support.activityLead);
      const item = {
        userId: support.activityLead.userId,
        email,
      };
      return item;
    });

    this.supportLeadsList = _.uniqBy(mappedList, 'userId');

    // WATCHERS
    this.$scope.$watch(
      '$ctrl.supportFilter',
      () => {
        this.supportFilterChanged();
      },
      true,
    );
  }

  openMenu($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  }

  // supportFilterChanged() {
  //   const filters = [];
  //   const { examSubject, activityLeadUserId } = this.supportFilter;
  //   if (examSubject) {
  //     const examSubjectFilter = (support) => {
  //       return support.metaData.examSubject === examSubject;
  //     };
  //     filters.push(examSubjectFilter);
  //   }
  //   if (activityLeadUserId) {
  //     const activityLeadFilter = (support) => {
  //       return support.activityLead.userId ===  activityLeadUserId;
  //     };
  //     filters.push(activityLeadFilter);
  //   }
  //   _.each(this.data, (support: any) => {
  //     support._matchesFilter = _.every(filters, (filter) => {
  //       filter(support);
  //     });
  //   });
  // }
  supportFilterChanged() {
    const filters = [];
    const { examSubject, activityLeadUserId } = this.supportFilter;
    if (examSubject) {
      filters.push(support => support.metaData.examSubject === examSubject);
    }
    if (activityLeadUserId) {
      filters.push(support => support.activityLead.userId === activityLeadUserId);
    }
    _.each(this.data, support => {
      support._matchesFilter = _.every(filters, filter => filter(support));
    });
  }

  getHumanName(key) {
    const foundKey = _.find(RegentsExam, (exam: any) => {
      return exam.subject.key === key;
    });
    return foundKey ? foundKey.subject.humanName : key;
  }

  activeSort(field) {
    return field === this.sortField;
  }

  renderTable(supports: ISchoolSupport[]) {
    const table = _.filter(supports, (support: ISchoolSupportExtended) => {
      const supportIsDeleted = this.imSupport.isDeleted(support);
      const supportCategoryIsRegentsPrep = this.imSupport.categoryIsRegentsPrep(support);

      // exclude supports that are completed; only shpw regents prep supports
      if (!supportIsDeleted && supportCategoryIsRegentsPrep) {
        support._statusObj = {
          currentState: '',
          order: null,
        };
        support._matchesFilter = true;
        support._enrollments = _.filter(this.storedStudentSupports, (studentSupport: IStudentSupport) => {
          const isActive = studentSupport.status === 'ACTIVE';
          const supportMatches = support._id === studentSupport.support.supportId;
          if (isActive && supportMatches) return true;
        }).length;
        support._startDate = support.schedule.startsOn;
        support._startAndEndDateString = this.imSupport.getStartAndEndDateString(support);
        support._leadHumanName = this.imSupport.getLeadHumanName(support);
        support._meetsOnScheduleString = this.imSupport.getMeetsOnScheduleString(support);
        support._startAndEndTimeString = this.imSupport.getStartAndEndTimeString(support);
        support._statusObj.currentState = this.imSupport.getFrontendStatus(support);
        support._canBeEdited = this.imSupport.canBeEditedBasedOnStatus(support);
        support._statusObj.order = this.imSupport.getSortOrderBasedOnFrontendStatus(support);
        support._examSubjectPrepsFor = this.getHumanName(support.metaData.examSubject);

        return true;
      } else {
        return false;
      }
    });

    return table;
  }

  // post init
  sortBy(field: string) {
    this.reverseSort = !this.reverseSort;
    this.initialSortFields = [];
    this.sortField = field;
    this.data = this.orderBy(this.data, [this.sortField], this.reverseSort);
  }

  createSupport(): void {
    const state = 'main.school.settings.supports.new';
    const params = {
      supportRequestOrigin: 'regents-prep-wizard',
    };
    const url = this.$state.href(state, params);
    this.$window.open(url, '_blank');
  }

  editSupport(supportId: string) {
    const state = 'main.school.settings.supports.edit';
    const params = { supportId };
    const url = this.$state.href(state, params);
    this.$window.open(url, '_blank');
  }

  deleteSupport(support: ISchoolSupportExtended) {
    const title = 'Confirm Deletion';
    const affirmationText = 'DELETE';
    const DELETED = 'DELETED';
    let snippet;
    if (support._enrollments === 0) {
      snippet = `No students are currently assigned to this support.`;
    } else {
      snippet = `This will remove ${support._enrollments} students from the support.`;
    }
    const text = `You are about to delete ${support.name}. ${snippet} Are you sure you want to do this?`;
    const promise = this.ConfirmationModal.show(title, text, affirmationText);
    promise
      .then(
        () => {
          /**
           * For now we need to create a new instance of the support from its POJO form in order
           * to regain access to the instance methods, in this case `$patchFields`.
           *
           * TODO - Moving to Redux will enable us to make our $http calls within Redux action creator functions.
           * Implementing that pattern will enable us to do away with the current $ngResource based model pattern. - JYR
           *
           */
          support.status = DELETED;
          const deletableSupport = new this.Support(support);
          deletableSupport.$patchFields(
            ['status'],
            () => {
              const sdcPayload = {
                schoolSupportId: deletableSupport._id,
                patch: { status: DELETED },
              };
              this.sdcActions.updateSchoolSupport(sdcPayload);
            },
            err => {
              console.error(err);
              this.Rollbar.error(`Unable to patch the support`, err);
            },
          );
        },
        () => {
          this.$mdDialog.hide();
        },
      )
      .catch(err => {
        console.error(err);
        this.Rollbar.error(`Unable to display Confirmation Modal`, err);
      });
  }
}
